import { createSelector } from '@ngrx/store';
import * as fromEcg from '../reducers/ecg-viewer.reducer';
import { selectLayoutEditState } from '../reducers';

export const culture = createSelector(selectLayoutEditState, fromEcg.culture);
export const selectorChartState = createSelector(selectLayoutEditState, fromEcg.chartState);

export const selectorFullState = createSelector(selectLayoutEditState, fromEcg.fullState);
export const selectorZoomFactor = createSelector(selectLayoutEditState, fromEcg.zoomFactor);
export const selectorIsFitBaseline = createSelector(selectLayoutEditState, fromEcg.isFitBaseline);
export const selectorFormat = createSelector(selectLayoutEditState, fromEcg.format);
export const selectorTimeAlignment = createSelector(selectLayoutEditState, fromEcg.timeAlignment);
export const selectorCulture = createSelector(selectLayoutEditState, fromEcg.culture);
export const selectorvisualComparison = createSelector(selectLayoutEditState, fromEcg.visualComparison);

export const selectorArrangement = createSelector(selectLayoutEditState, fromEcg.arrangement);

export const selectorPaperOpacity = createSelector(selectLayoutEditState, fromEcg.paperOpacity);

export const selectorPaperRate = createSelector(selectLayoutEditState, fromEcg.paperRate);

export const selectorTraceSpacing = createSelector(selectLayoutEditState, fromEcg.traceSpacing);

export const selectorStudySpacing = createSelector(selectLayoutEditState, fromEcg.studySpacing);

export const selectorHorizontalStudySpacing = createSelector(selectLayoutEditState, fromEcg.horizontalStudySpacing);

export const selectorFiducialPointsVisible = createSelector(selectLayoutEditState, fromEcg.fiducialPointsVisible);

export const selectorPrintAsDisplayed = createSelector(selectLayoutEditState, fromEcg.printAsDisplayed);

export const selectorSummaryVisible = createSelector(selectLayoutEditState, fromEcg.summaryVisible);

export const selectorDetailsVisible = createSelector(selectLayoutEditState, fromEcg.detailsVisible);

export const selectorCaliperMode = createSelector(selectLayoutEditState, fromEcg.caliperMode);

export const selectorCustomCommand = createSelector(selectLayoutEditState, fromEcg.customCommand);
